<template>
    <DsModal
        center
        show-back
        size="med"
        :is-open="isOpen"
        :title="editorTitle"
        @back="closeModal"
    >
        <template #header>
            <DsFilledButton
                data-qa="save-button"
                @click="updateConfig"
            >
                {{ $t('funnel.campaign.task.outcome.save') }}
            </DsFilledButton>
        </template>
        <DsInputField
            v-model="name"
            data-qa="task-category-title"
            :label="$t('funnel.campaign.task.outcome.category.label')"
            :submitted="invalidName"
            required
        >
            <template #error>
                {{ $t('funnel.campaign.task.outcome.required') }}
            </template>
        </DsInputField>
    </DsModal>
</template>

<script>
import {
    updateCategory,
    addCategory,
} from '../task.outcome.api';

export default {
    props: {
        savedElement: {
            type: Object,
            default: () => (undefined),
        },
        editing: {
            type: Boolean,
            required: true,
        },
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close-editor', 'close-reload'],
    data() {
        return {
            name: '',
            invalidName: false,
        };
    },
    computed: {
        editorTitle() {
            return this.editing
                ? this.$t('funnel.campaign.task.category.new')
                : this.$t('funnel.campaign.task.outcome.new.category');
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            if (this.savedElement) {
                this.name = this.savedElement.name;
            }
        },
        closeModal() {
            this.$emit('close-editor');
        },
        closeModalAndReload() {
            this.$emit('close-reload');
        },
        setIsValidName() {
            this.invalidName = this.name === '';
        },
        isValid() {
            this.setIsValidName();

            return !this.invalidName;
        },
        async updateConfig() {
            if (this.isValid()) {
                if (this.editing) {
                    const payload = {
                        id: this.savedElement.id,
                        name: this.name,
                    };

                    await updateCategory(payload);
                } else {
                    const payload = {
                        name: this.name,
                    };

                    await addCategory(payload);
                }
                this.closeModalAndReload();
            }
        },
    },
};
</script>
